<template>
  <div id="organisation-integrations">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ $t("organisation.integration.title") }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" icon="fas fa-redo-alt" :loading="loading == 'testLoading'" size="mini" @click="testLoading" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body">
            <div class="integration-grid">
              <!-- <div class="integration-card">
                <div class="integration-icon">
                  <i class="far fa-credit-card"></i>
                </div>
                <h6>{{ $t("organisation.integration.build") }}</h6>
                <p>{{ $t("organisation.integration.buildMsg") }}</p>
                <el-button
                  round
                  type="primary"
                  @click="
                    paymentPosId = null;
                    addPaymentMethodDialog = !addPaymentMethodDialog;
                  "
                >
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.addPayment") }}
                </el-button>
              </div> -->
              <div class="integration-card">
                <div class="integration-icon">
                  <i class="fa fa-rocket"></i>
                </div>
                <h6>{{ $t("organisation.integration.build") }}</h6>
                <p>{{ $t("organisation.integration.buildMsg") }}</p>
                <a href="mailto:support@holacon.com">{{ $t("organisation.integration.buildLink") }}</a>
              </div>

              <div class="integration-card">
                <div class="integration-icon">
                  <i class="fas fa-chalkboard"></i>
                </div>
                <h6>{{ $t("organisation.integration.request") }}</h6>
                <p>{{ $t("organisation.integration.requestMsg") }}</p>
                <a href="mailto:support@holacon.com">{{ $t("organisation.integration.requestLink") }}</a>
              </div>

              <div class="integration-card">
                <div class="integration-icon">
                  <i class="fas fa-exchange-alt"></i>
                </div>
                <h6>{{ $t("organisation.integration.requestAPI") }}</h6>
                <p>{{ $t("organisation.integration.requestAPIMsg") }}</p>
                <a href="mailto:support@holacon.com">{{ $t("organisation.integration.requestAPILink") }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ $t("organisation.integration.paymentMethods") }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-button
                  v-if="subscriptionPermissions && subscriptionPermissions.bankPosForOnlinePayments"
                  @click="
                    paymentPosId = null;
                    addPaymentMethodDialog = !addPaymentMethodDialog;
                  "
                  icon="fas fa-plus"
                  size="mini"
                  type="primary"
                  round
                >
                  {{ $t("organisation.integration.add") }}
                </el-button>
                <el-button v-else icon="fas fa-plus" size="mini" round type="primary" @click="$router.push(`/organisation/${currentOrganization.id}/billing`)">{{ $t("organisation.integration.add") }}</el-button>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" :loading="loading == 'refreshPayment'" size="mini" @click="refresh" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="mb-3" v-if="(subscriptionPermissions == null || (subscriptionPermissions && !subscriptionPermissions.bankPosForOnlinePayments))">
            <upgrade-overlay height="200px" :organisationID="currentOrganization.id"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="currentOrganization.paymentProviders.length > 0">
            <div class="custom-grid-table-header online-payment-list-header">
              <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.paymentMethod") }}</span>
              <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.currency") }}</span>
              <span></span>
            </div>
            <div class="online-payment-list-items">
              <div class="item" v-for="posItem in currentOrganization.paymentProviders" :key="posItem.posId">
                <span>{{ posItem.posId + " - " + posItem.title }}</span>
                <span>{{ getEnumsDisplay("Currency", posItem.currency) }}</span>
                <div class="btn-list">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        paymentPosId = posItem.posId;
                        addPaymentMethodDialog = !addPaymentMethodDialog;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.test')" placement="top">
                    <el-button
                      type="warning"
                      icon="fas fa-credit-card"
                      circle
                      size="mini"
                      @click="
                        paymentPosId = posItem.posId;
                        testPaymentModal = !testPaymentModal;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteProviders(posItem.posId)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'delete' + posItem.posId" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <el-alert type="info" :closable="false" show-icon :title="$t('organisation.integration.noDataPaymentMethod')"></el-alert>
          </div>
        </div>
        <el-dialog :visible.sync="addPaymentMethodDialog" :close-on-click-modal="false" :title="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.addEditPayment')" class="medium" center append-to-body destroy-on-close>
          <AddOrUpdatePaymentMethods v-if="addPaymentMethodDialog" :paymentPosId="paymentPosId" @closeDialog="addPaymentMethodDialog = false" @deleteProviders="deleteProviders" />
        </el-dialog>
        <el-dialog :visible.sync="testPaymentModal" :close-on-click-modal="false" :title="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.test')" class="medium" center append-to-body destroy-on-close>
          <TestPaymentModal v-if="testPaymentModal" :paymentPosId="paymentPosId" @closeDialog="testPaymentModal = false" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AddOrUpdatePaymentMethods from "../components/register-form/addOrUpdatePaymentMehods.vue";
import slugify from "slugify";
import TestPaymentModal from "../components/register-form/testPaymentModal.vue";
export default {
  name: "OrganisationIntegrations",
  components: {
    AddOrUpdatePaymentMethods,
    TestPaymentModal
  },
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisationIntegrations")
    };
  },
  data() {
    return {
      addPaymentMethodDialog: false,
      paymentPosId: null,
      loading: false,
      helpUrl: "",
      testPaymentModal: false,
      timeout: null,
      paymentPosId: null
    };
  },
  async created() {
    if (this.$route.query.orderNumber != null && this.$route.query.orderNumber != undefined) {
      var res = await this.$store.dispatch("testGetPaymentInfo", this.$route.query.orderNumber);
      this.$confirm(res.data.alert.message, res.data.data.bankName, {
        confirmButtonText: "Kapat",
        cancelButtonText: "Cancel",
        showCancelButton: false,
        showClose: false,
        type: res.data.alert.hasError ? "error" : "success"
      }).then(() => {
        console.log(this.$route);
        window.history.pushState({}, document.title, "/" + this.$route.path);
        console.log(this.$route, "second");
      });
    }
  },
  methods: {
    testLoading() {
      this.loading = "testLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    async refresh() {
      this.loading = "refreshPayment";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getOrganization");
        this.loading = false;
      }, 500);
    },
    async deleteProviders(id) {
      this.loading = "delete" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deletePaymentProviders", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getOrganization");
        }
        this.loading = false;
      }, 500);
    }
  },
  computed: {
    subscriptionPermissions() {
      return this.$store.getters.getSubscriptionPermission;
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    }
  }
};
</script>

<style lang="less">
#organisation-integrations {
  width: 100%;

  .content-wrapper {
    .card {
      .online-payment-list-header {
        grid-template-columns: 1fr 90px 90px;
      }
      .online-payment-list-items {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .item {
          margin-bottom: 8px;
          i.burger {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
            cursor: grab;
            &.me {
              color: #ccc;
            }
          }
          .btn-list {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-end;
            gap: 0.2rem;
            .el-button {
              margin: 0;
            }
          }
          padding: 10px;
          gap: 0.5rem;
          align-items: center;
          display: grid;
          border-radius: 8px;
          grid-template-columns: 1fr 90px 90px;
          background-color: #f1f1f1;

          &:last-child {
            margin-bottom: unset;
          }
          &.passive {
            background-color: #fff2f2 !important;
          }
          .stand-grid-item-img-title {
            display: flex;
            gap: 1rem;
            font-weight: 500;
            align-items: center;
            .stand-grid-item-title {
              font-weight: bold;
              display: flex;
              flex-direction: column;
              gap: 0.25rem;
            }

            & > .img {
              border-radius: 8px;
              width: 112px;
              height: 50px;
              background-size: cover;
              background-position: center center;
              background-repeat: no-repeat;
              overflow: hidden;
              border: 3px solid white;
            }
          }
        }
      }
    }
    .card-body {
      margin-top: 20px;

      .integration-grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 10px;
        margin: 0px;

        .integration-card {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 24px 16px;
          border: 0.5px solid #d6d9d9;
          border-radius: 8px;

          &:hover {
            background-color: #fbfbfb;
            transition: all 0.3s ease 0s;
          }

          .integration-icon {
            border: 5px solid #d6d9d9;
            height: 50px;
            border-radius: 50%;
            min-width: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;

            i {
              font-size: 20px;
              color: #268ea6;
              text-align: center;
            }
          }

          h6 {
            font-size: 16px;
            font-weight: 500;
            color: #292f3b;
            margin: 12px 0px 2px 0px;
            font-weight: 500;
            text-align: center;
          }

          p {
            font-size: 13px;
            font-weight: 400;
            color: #505763;
            margin: 4px 0px;
            font-weight: 400;
            text-align: center;
          }

          a {
            background: #268ea6;
            padding: 10px 16px;
            border-radius: 20px;
            color: white;
            font-weight: 500;
            border: unset;
            margin-top: 15px;
            text-decoration: unset;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationIntegrations.vue